import BaseParametersFormattingStrategy from "../../../parametersFormatting/BaseParametersFormattingStrategy";
import ChartParametersFormatter from "./ChartParametersFormatter"
import messageResource from "../../../messageResource"
import ATReportParamsStringBuilder from '../../reportParamsStringBuilder/ATReportParamsStringBuilder'
import {Feature} from '../../../features'

export default class ChartParametersFormattingStrategy extends BaseParametersFormattingStrategy {
    createParametersFormatter({selectorsData, dateFormat, reportAuthorizationInfo}) {
        const ugrEnabled = selectorsData.enabledFeatures ?
                         selectorsData.enabledFeatures.hasOwnProperty(Feature.UGR) :
                         null
        const tzgEnabled = selectorsData.enabledFeatures ?
                         selectorsData.enabledFeatures.hasOwnProperty(Feature.TZG) :
                         null
        return new ChartParametersFormatter().init({
            selectorsData: selectorsData,
            dateFormat: dateFormat,
            ugrFeatureEnabled: ugrEnabled,
            tzgFeatureEnabled: tzgEnabled,
            reportAuthorizationInfo: reportAuthorizationInfo,
            reportParamsStringBuilderConstructor: ATReportParamsStringBuilder,
        })
    }

    formatMainPartOfLightboxTitle(selectedParameters) {
        return messageResource.getMessage(
            "report.chart_pdf_preview.title",
            [
                this.parametersFormatter.formatChartTypeValue(selectedParameters.chartTypeValue),
                this.parametersFormatter.formatGroupingLevelValue(selectedParameters.groupingLevelValue),
                this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters)
            ]
        );
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/parametersFormatters/ChartParametersFormattingStrategy.js